export class DeleteOrderBillModel {
  public orderBillId: string;
  public managerPin: string;
  public venueId: string;

}
